import { DOCUMENT, inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { ToastUIEditorComponent } from "../../oex-ui-kit/components/toastui-editor/toastui-editor.component";
import { NotificationsService } from '../../oex-ui-kit/services/notifications.service';
import { APIService } from "./api.service";
import { AuthService } from "./auth.service";
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class StartupService {
  private api = inject(APIService);
  private auth = inject(AuthService);
  private ns = inject(NotificationsService);
  private readonly router = inject(Router);
  private readonly platformId = inject(PLATFORM_ID);
  private readonly doc = inject<Document>(DOCUMENT);

  async initialize() {
    // this.insertOnetrustScripts();
    this.ns.disableLinks.set(true);
    // Change TUI toolbar
    ToastUIEditorComponent.changeToolbar(
      ['heading', 'bold', 'italic', 'strike'],
      ['hr', 'quote'],
      ['ul', 'ol', 'indent', 'outdent'],
      ['link']
    );
    // ToastUIEditorComponent.defaultUploadEndpoint = this.api.getEditorImageUploadEndpoint();
    try {
      await Promise.all([
        this.auth.initializeUserState()
      ])
    } catch (e) {
      console.error(e);
    }
    return Promise.resolve();
  }

  private insertOnetrustScripts() {
   /*  if (isPlatformBrowser(this.platformId)) {
      return;
    } */
    const scriptKey = APP_IS_PROD
      ? '389f2878-8b31-4ac9-9070-21844493ce6f'
      : '389f2878-8b31-4ac9-9070-21844493ce6f-test';


    // Insert OneTrust scripts as a block using insertAdjacentHTML
    /* const onetrustScripts = `
      <!-- OneTrust Cookies Consent Notice start -->
      <script type="text/javascript" src="https://cdn.cookielaw.org/consent/${scriptUrl}/OtAutoBlock.js"></script>
      <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" type="text/javascript" charset="UTF-8" data-domain-script="${scriptUrl}" data-language="en"></script>
      <script type="text/javascript">
        function OptanonWrapper() { }
      </script>
      <!-- OneTrust Cookies Consent Notice end -->`; */

    const onetrustScripts = `
      <!-- OneTrust Cookies Consent Notice start -->
      <script src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"  type="text/javascript" charset="UTF-8" data-domain-script="${scriptKey}" ></script>
      <script type="text/javascript">
        function OptanonWrapper() { }
      </script>
      <!-- OneTrust Cookies Consent Notice end -->`;

    this.doc.head.insertAdjacentHTML('beforeend', onetrustScripts);
  }
}
